// extracted by mini-css-extract-plugin
export var animationDuration = "5000ms";